import { useMemo } from "react";
import { PolygonDrawerProps } from "../../models/polygon";
import { MapContainer, TileLayer } from "react-leaflet";
import DrawController from "./DrawController";
import GeoSearchControl from "./GeoSearchControl";

import './index.css'

export const MapPolygonDrawer: React.FC<PolygonDrawerProps> = ({
  onPolygonChange,
  value = null,
  center = [33.8886, 35.4955],
  zoom = 11,
  readOnly = false,
}) => {

  const handleChange = useMemo(() => onPolygonChange ?? (() => {}), [onPolygonChange]);

  return (
    <div className="w-full h-[480px] rounded-2xl overflow-hidden shadow relative">
      <MapContainer center={center} zoom={zoom} style={{ width: "100%", height: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {/* Country/City search box overlayed in top-left */}
        <GeoSearchControl
          countryCodes={undefined /* e.g. "lb" to limit to Lebanon */}
          onPlaceSelected={() => {
            // Clear polygon since user navigated to a new AOI
            handleChange(null);
          }}
        />

        <DrawController onPolygonChange={handleChange} readOnly={readOnly} initialPolygon={value} />
      </MapContainer>
    </div>
  );
};
